import { render } from "./Dashboard-pendidikan.vue?vue&type=template&id=39cb1e64"
import script from "./Dashboard-pendidikan.vue?vue&type=script&lang=js"
export * from "./Dashboard-pendidikan.vue?vue&type=script&lang=js"

import "./Dashboard-pendidikan.vue?vue&type=style&index=0&id=39cb1e64&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__